import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {PRIVACY_POLICY_URL} from '../../constants/app.constants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  registerForm: UntypedFormGroup;
  submitted = false;
  errorMessage: string;
  privacyPolicyUrl = PRIVACY_POLICY_URL;

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    public authenticationService: AuthenticationService,
    public utilsService: UtilsService
  ) {
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      rememberMe: [true],
    });

  }

  get controls() {
    return this.registerForm.controls;
  }

  login() {
    this.submitted = true;
    if (!this.registerForm.valid) {
      this.utilsService.displayMessage('Error on form', 'Please check the form values and resubmit', 'warn');
      return;
    }
    this.errorMessage = null;
    this.authenticationService.loginUsingWs$(
      this.registerForm.value.email,
      this.registerForm.value.password,
      this.registerForm.value.rememberMe
    ).subscribe({
        next: () => {
          this.submitted = false;
          this.authenticationService.displayChangePasswordAlert = false;
          if (this.authenticationService.userHasOneOfThosePermissions(['mustSetupAuthenticator'])) {
            this.utilsService.saveCookie('setup', 1);
          }
          if (this.authenticationService.userHasOneOfThosePermissions(['mustChangePassword'])) {
            this.router.navigate(['change-password']);
          } else if (this.authenticationService.userHasOneOfThosePermissions(['incompleteLogin'])) {
            this.utilsService.saveCookie('mfa', 1);
          } else {
            const redirectUrl = this.authenticationService.redirectUrl;
            if (redirectUrl) {
              this.authenticationService.redirectUrl = null;
              this.utilsService.navigate(redirectUrl);
            } else {
              const userAuthenticated = (this.authenticationService.getUserCurrent().company.uniqid === 'admin') ? 'mckay' : 'client';
              location.assign('/#/' + userAuthenticated + '/' + this.authenticationService.getUserCurrent().company.uniqid);
            }
          }
        },
        error: error => {
          if (error.status === 401) {
            this.errorMessage = 'The username and/or password is invalid.';
          } else if (error.status === 403) {
            this.errorMessage = 'This account is not permissioned for login. Please contact your Portal admins for help.';
          } else if (error.status === 0) {
            this.errorMessage = 'An error has occurred. Please try again. If the error persists, please contact site administrator.';
          } else if (error.status === 429) {
            this.errorMessage = 'Too many failed login attempts. Please try again in 5 minutes.';
          } else {
            this.errorMessage = 'Something went wrong during authentication process! <br>Please try again.';
          }
        }
      }
    );
  }

  showErrorMessage(fieldName: string): boolean {
    if (!this.registerForm.controls[fieldName]) {
      return false;
    }
    return !this.registerForm.controls[fieldName].valid && this.submitted;
  }
}
